import React from 'react';
import PropTypes from 'prop-types';
import StyledHeading, { Button } from './StyledHeading';
import Box from '../../Box';
import Title from './Title';
import BackButton from './BackButton';
import RightButton from './RightButton';

var Heading = function Heading(_ref) {
  var children = _ref.children;
  var backButton = null;
  var title = null;
  var rightButtons = [];

  var defineComponent = function defineComponent(child) {
    if (!child) return;
    if (child.type.displayName === Title.displayName) title = child;
    if (child.type.displayName === BackButton.displayName) backButton = child;
    if (child.type.displayName === RightButton.displayName) rightButtons.push(child);
  };

  if (Array.isArray(children)) {
    children.forEach(function (child) {
      return defineComponent(child);
    });
  } else {
    defineComponent(children);
  }

  return /*#__PURE__*/React.createElement(StyledHeading, null, backButton || /*#__PURE__*/React.createElement(Button, null), title || /*#__PURE__*/React.createElement(Box, {
    w: "100%"
  }), /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    "justify-content": "space-between",
    alignItems: "center"
  }, rightButtons.length > 0 ? rightButtons : /*#__PURE__*/React.createElement(Button, null)));
};

Heading.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
};
Heading.defaultProps = {
  children: undefined
};
export default Heading;